<template>
  <div>
    <div class="form_label">{{ label }}：</div>
    <div class="form_value">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ["label"],
};
</script>

<style lang="scss" scoped>
.form_label {
  font-size: 16px;
  font-weight: 500;
  color: #5ba7ad;
  line-height: 22px;
  margin-bottom: 11px;
}
.form_value {
  font-size: 16px;
  font-weight: 400;
  color: rgba(50, 50, 50, 1);
  line-height: 22px;
  margin-bottom: 24px;
  min-height: 22px;
}
</style>
